import {
  IonIcon,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import LoginKeys from '../LoginKeys/LoginKeys';
import styles from './BiometryPinModal.module.scss';

export interface BiometryPinModalProps {
  onDismiss: (configure: boolean) => void;
  onResetPassword: () => void;
}

export default function BiometryPinModal({
  onDismiss,
  onResetPassword,
}: BiometryPinModalProps) {
  const rejectBiometry = () => onDismiss(false);
  const username = localStorage.getItem('username');

  return (
    <div id="bottom-modal-biometry-pin" className={styles.container}>
      <div className={styles.closeButton}>
        <IonIcon
          id="button-close-setup-biometry-modal"
          icon={closeOutline}
          onClick={rejectBiometry}
        />
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.titleContainer}>
          <h3 className={styles.title}>Confirma que eres tú...</h3>
          <p className={styles.subtitle}>
            Introduce tu PIN para configurar tu login biométrico:
          </p>

        </div>
        <div className={styles.buttons}>
          <LoginKeys
            username={username!}
            resentPassword={() => {
              onResetPassword();
              onDismiss(false);
            }}
            loginError={() => { }}
            biometryUsernameMismatch={false}
            biometryAutoAccept
            redirectOnSuccess={false}
            onBiometryEnabled={() => {
              onDismiss(true);
            }}
          />
        </div>
      </div>
    </div>
  );
}
